module.exports = __webpack_public_path__ + "static/media/kaylee_tran.29b833cd.png";